/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Layout\AdminLayout.jsx
 * ВЕРСИЯ: 4.0.0 - Strategy 2026 v2.0 (Subscriptions + Leads)
 * ДАТА: 26.01.2026
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/AdminLayout.css';

export const AdminLayout = ({ children, user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userToken');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userRole');
    localStorage.removeItem('isAdmin');
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  const menuItemClass = (path) => {
    return 'admin-menu-item' + (isActive(path) ? ' active' : '');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <span className="admin-sidebar-icon">🎁</span>
          <span className="admin-sidebar-title">DARY Admin</span>
        </div>

        <nav className="admin-sidebar-menu">
          {/* ============================================ */}
          {/* СЕКЦИЯ: ГЛАВНОЕ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">📊 ГЛАВНОЕ</span>
          </div>
          
          <button className={menuItemClass('/admin/dashboard')} onClick={() => navigate('/admin/dashboard')}>
            🏠 Дашборд
          </button>

          <button className={menuItemClass('/admin/analytics')} onClick={() => navigate('/admin/analytics')}>
            📈 Аналитика
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: ПОЛЬЗОВАТЕЛИ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">👥 ПОЛЬЗОВАТЕЛИ</span>
          </div>

          <button className={menuItemClass('/admin/users')} onClick={() => navigate('/admin/users')}>
            👤 Все пользователи
          </button>

          <button className={menuItemClass('/admin/businesses')} onClick={() => navigate('/admin/businesses')}>
            🏢 Бизнесы
          </button>

          <button className={menuItemClass('/admin/verification')} onClick={() => navigate('/admin/verification')}>
            ✅ Верификация
          </button>

          <button className={menuItemClass('/admin/users/blocked')} onClick={() => navigate('/admin/users/blocked')}>
            🚫 Заблокированные
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: БИЗНЕС (NEW) */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">💎 БИЗНЕС</span>
          </div>

          <button className={menuItemClass('/admin/subscriptions')} onClick={() => navigate('/admin/subscriptions')}>
            💳 Подписки
          </button>

          <button className={menuItemClass('/admin/wallets')} onClick={() => navigate('/admin/wallets')}>
            💰 Brand Wallets
          </button>
		  
		  {/* ============================================ */}
          {/* СЕКЦИЯ: DARY UNIVERSAL */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">🎁 DARY UNIVERSAL</span>
          </div>

          <button className={menuItemClass('/admin/dary')} onClick={() => navigate('/admin/dary')}>
            📊 Дашборд
          </button>

          <button className={menuItemClass('/admin/dary/users')} onClick={() => navigate('/admin/dary/users')}>
            👥 Юзеры
          </button>

          <button className={menuItemClass('/admin/dary/referrals')} onClick={() => navigate('/admin/dary/referrals')}>
            🔗 Рефералы
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: КАМПАНИИ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">📢 КАМПАНИИ</span>
          </div>

          <button className={menuItemClass('/admin/campaigns')} onClick={() => navigate('/admin/campaigns')}>
            📋 Все кампании
          </button>

          <button className={menuItemClass('/admin/campaigns/analytics')} onClick={() => navigate('/admin/campaigns/analytics')}>
            📊 Статистика
          </button>
		  
		  <button className={menuItemClass('/admin/ad-manager')} onClick={() => navigate('/admin/ad-manager')}>
            📢 Ad Manager
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: ПОДАРКИ & ЛИДЫ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">🎁 ПОДАРКИ & ЛИДЫ</span>
          </div>

          <button className={menuItemClass('/admin/brand-gifts')} onClick={() => navigate('/admin/brand-gifts')}>
            🎨 Brand Gifts
          </button>

          <button className={menuItemClass('/admin/promocodes')} onClick={() => navigate('/admin/promocodes')}>
            🎟️ Промокоды
          </button>

          <button className={menuItemClass('/admin/leads')} onClick={() => navigate('/admin/leads')}>
            👥 Лиды
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: ФИНАНСЫ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">💵 ФИНАНСЫ</span>
          </div>

          <button className={menuItemClass('/admin/transactions')} onClick={() => navigate('/admin/transactions')}>
            📜 Транзакции
          </button>

          <button className={menuItemClass('/admin/billing')} onClick={() => navigate('/admin/billing')}>
            💳 Billing
          </button>

          <button className={menuItemClass('/admin/commissions')} onClick={() => navigate('/admin/commissions')}>
            📊 Комиссии
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: БЕЗОПАСНОСТЬ */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">🔒 БЕЗОПАСНОСТЬ</span>
          </div>

          <button className={menuItemClass('/admin/security/alerts')} onClick={() => navigate('/admin/security/alerts')}>
            ⚠️ Алерты
          </button>

          <button className={menuItemClass('/admin/security/logs')} onClick={() => navigate('/admin/security/logs')}>
            📝 Логи
          </button>

          <button className={menuItemClass('/admin/security/ip-blocks')} onClick={() => navigate('/admin/security/ip-blocks')}>
            🚷 IP блокировки
          </button>

          {/* ============================================ */}
          {/* СЕКЦИЯ: СИСТЕМА */}
          {/* ============================================ */}
          <div className="admin-menu-section">
            <span className="admin-section-label">⚙️ СИСТЕМА</span>
          </div>

          <button className={menuItemClass('/admin/settings')} onClick={() => navigate('/admin/settings')}>
            🔧 Настройки
          </button>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <span className="admin-user-email">{user?.email || 'Admin'}</span>
            <span className="admin-user-role">Administrator</span>
          </div>
          <button className="admin-logout-btn" onClick={handleLogout}>
            🚪 Выход
          </button>
        </div>
      </aside>

      <main className="admin-main-content">
        <div className="admin-content-header">
          <span className="admin-brand">🎁 DARY</span>
          <span className="admin-version">v4.0.0</span>
        </div>
        <div className="admin-content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;